import { useCallback, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { SESSION_IDLE_WARNING_MS } from "constants/session";

export interface UseIdleHandlerProps {
  enabled?: boolean;
  timeout: number;
  warningTime?: number;
  onIdle: () => void;
}

interface UseIdleHandlerResult {
  showWarning: boolean;
  continueSession: () => void;
}

export const useIdleHandler = ({
  enabled = true,
  timeout,
  warningTime = SESSION_IDLE_WARNING_MS,
  onIdle,
}: UseIdleHandlerProps): UseIdleHandlerResult => {
  const [showWarning, setShowWarning] = useState(false);

  const { reset } = useIdleTimer({
    disabled: !enabled,
    timeout,
    promptBeforeIdle: warningTime,
    onPrompt: () => setShowWarning(true),
    onIdle: () => {
      setShowWarning(false);
      onIdle();
    },
    onActive: () => setShowWarning(false),
    debounce: 500,
  });

  useEffect(() => {
    if (!enabled) {
      setShowWarning(false);
    }
  }, [enabled]);

  const continueSession = useCallback(() => {
    setShowWarning(false);
    reset();
  }, [reset]);

  return {
    showWarning,
    continueSession,
  };
};
